import { useReducer } from "react";

export default function (init) {
  return useReducer((s, ns) => ({ ...s, ...ns }), init);
}